import { getStockStatusConfig } from '~/domain/stockStatus';
import {
  formatReleaseDateLarge,
  formatReleaseDateShort,
  getCurrentDateUnix
} from '~/utils/dates';

type Props = {
  releaseDate?: EpochTimeStamp;
  releaseDateFormat?: 'short' | 'long';
  size?: 'LARGE' | 'DEFAULT';
  status?: string;
};

const StockStatus = ({
  status,
  size,
  releaseDate = 0,
  releaseDateFormat = 'short'
}: Props) => {
  const stockStatus =
    releaseDate > getCurrentDateUnix()
      ? getStockStatusConfig('upcoming')
      : getStockStatusConfig(status ?? '');

  if (!stockStatus) return null;

  let textSize;
  let padding;

  switch (size) {
    case 'LARGE':
      textSize = 'text-xs';
      padding = 'py-2 px-4';
      break;
    default:
      textSize = 'text-[10px]';
      padding = 'py-1 px-2';
      break;
  }

  const formattedReleaseDate =
    releaseDateFormat === 'long'
      ? formatReleaseDateLarge(releaseDate)
      : formatReleaseDateShort(releaseDate);

  return (
    <span
      data-cy="stock-status"
      className={`${textSize} ${padding} rounded-full border bg-white font-semibold ${stockStatus.textColourClass} ${stockStatus.borderColourClass}`}
    >
      {stockStatus.text === 'Upcoming' && releaseDate > getCurrentDateUnix()
        ? formattedReleaseDate
        : stockStatus.text}
    </span>
  );
};

export default StockStatus;
